// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreatedBy
 */
export interface CreatedBy {}

/**
 * Check if a given object implements the CreatedBy interface.
 */
export function instanceOfCreatedBy(value: object): value is CreatedBy {
  return true;
}

export function CreatedByFromJSON(json: any): CreatedBy {
  return CreatedByFromJSONTyped(json, false);
}

export function CreatedByFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatedBy {
  return json;
}

export function CreatedByToJSON(json: any): CreatedBy {
  return CreatedByToJSONTyped(json, false);
}

export function CreatedByToJSONTyped(
  value?: CreatedBy | null,
  ignoreDiscriminator: boolean = false
): any {
  return value;
}
